// FEAT-072 (MVP-18.39) — caregiver service address visibility in booking detail UI.

export type BookingStatus =
  | 'REQUESTED'
  | 'SCHEDULED'
  | 'CONFIRMED'
  | 'IN_PROGRESS'
  | 'COMPLETED'
  | 'CANCELLED'
  | 'NO_SHOW';

export type ViewerRole = 'PATIENT' | 'CAREGIVER' | 'ADMIN' | null | undefined;

export const REDACTED_SERVICE_ADDRESS_PLACEHOLDER =
  'Service address is available only while this booking is active.';

const ACTIVE_BOOKING_STATUSES = new Set<BookingStatus>([
  'REQUESTED',
  'SCHEDULED',
  'CONFIRMED',
  'IN_PROGRESS',
]);

export const isActiveBookingStatus = (status: BookingStatus): boolean =>
  ACTIVE_BOOKING_STATUSES.has(status);

export type ServiceAddressDisplay = {
  text: string;
  isRedactedPlaceholder: boolean;
};

export const getServiceAddressDisplay = (
  serviceAddress: string | null | undefined,
  status: BookingStatus,
  viewerRole: ViewerRole,
): ServiceAddressDisplay | null => {
  if (viewerRole === 'CAREGIVER') {
    if (serviceAddress) {
      return { text: serviceAddress, isRedactedPlaceholder: false };
    }

    if (!isActiveBookingStatus(status)) {
      return { text: REDACTED_SERVICE_ADDRESS_PLACEHOLDER, isRedactedPlaceholder: true };
    }

    return null;
  }

  if ((viewerRole === 'PATIENT' || viewerRole === 'ADMIN') && serviceAddress) {
    return { text: serviceAddress, isRedactedPlaceholder: false };
  }

  return null;
};

export const shouldShowServiceAddressSection = (
  serviceAddress: string | null | undefined,
  status: BookingStatus,
  viewerRole: ViewerRole,
): boolean => getServiceAddressDisplay(serviceAddress, status, viewerRole) !== null;
